const LOCAL_API_BASE_URL = 'http://localhost:8000';
const STAGING_API_BASE_URL = 'https://app-server-staging.muzology.com';
const PRODUCTION_API_BASE_URL = 'https://server.muzology.com';

const PRODUCTION_WEBSITE_HOSTS = new Set([
    'muzology.com',
    'www.muzology.com',
]);

const STAGING_WEBSITE_HOSTS = new Set([
    'next.muztech.net',
    'stage.muzology.com',
    'web-dev.muzology.com',
    'web-staging.muzology.com',
]);

function normalizeApiBaseUrl(value) {
    return value.replace(/\/$/, '');
}

function extractHostname(value) {
    if (!value) {
        return null;
    }

    try {
        if (value.startsWith('http://') || value.startsWith('https://')) {
            return new URL(value).hostname.toLowerCase();
        }
        return value.toLowerCase();
    } catch {
        return null;
    }
}

function resolveMuzologyApi(configuredApi, options = {}) {
    const browserHostname = extractHostname(options.browserLocation ?? options.browserHostname ?? null);
    const normalizedConfiguredApi = configuredApi ? normalizeApiBaseUrl(configuredApi) : null;
    const vercelEnv = options.vercelEnv ?? process.env.NEXT_PUBLIC_VERCEL_ENV ?? null;

    if (browserHostname && PRODUCTION_WEBSITE_HOSTS.has(browserHostname)) {
        return PRODUCTION_API_BASE_URL;
    }

    if (browserHostname && (STAGING_WEBSITE_HOSTS.has(browserHostname) || browserHostname.endsWith('.vercel.app'))) {
        return STAGING_API_BASE_URL;
    }

    if (vercelEnv === 'production') {
        return PRODUCTION_API_BASE_URL;
    }

    if (vercelEnv === 'preview') {
        return STAGING_API_BASE_URL;
    }

    return normalizedConfiguredApi ?? LOCAL_API_BASE_URL;
}

module.exports = {
    LOCAL_API_BASE_URL,
    PRODUCTION_API_BASE_URL,
    STAGING_API_BASE_URL,
    extractHostname,
    normalizeApiBaseUrl,
    resolveMuzologyApi,
};
